/* =========================
 * API
 * ========================= */
export const API_BASE_URL = 'https://sta.fielpet.com';

export const API_ENDPOINTS = {
  SINIESTRO_IMAGENES: '/app/siniestro/imagenes-siniestro',
} as const;

/* =========================
 * STORAGE / FILES
 * ========================= */
//url prod
export const S3_BASE_URL = 'https://fielpet.s3.sa-east-1.amazonaws.com/';
//url test
// export const S3_BASE_URL = 'https://s3.sa-east-1.amazonaws.com/test.fielpet.com.ar/';
export const S3_PATHS = {
  ARCHIVOS_ADJUNTOS: 'archivos_adjuntos',
} as const;
